const options = {
    rootClass: 'zp-device-slider',
    initType: 1
};

LoaderFactory(options, (function (w, d, $, undefined) {

    const _w = $(w);
    const _d = $(d);

    let mySlick;

    class DeviceSlider {

        /**
         * Konstruktor
         * @param {Selector} root
         */
        constructor(root) {
            this.initSlick(root);
            this.resizeWindow(root);
            this.start(root);
        }


        /**
         * foo
         * @param {Selector} root
         */
        start(root) {



        }

        /**
         * initialisiert Slick Slider
         * @param {Selector} root
         */
        initSlick (root) {

            this.changedSlickImageHeight(root, function() {

                let slickSlider =  $('#' + root.attr('id') + ' .zp-device-slider-slick');

                mySlick = slickSlider.slick({
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    adaptiveHeight: true,
                    prevArrow: $('#' + root.attr('id') + ' .zp-device-slider-arrow-left'),
                    nextArrow: $('#' + root.attr('id') + ' .zp-device-slider-arrow-right')
                });

            });

                // $('.zp-device-slider-element-scrollable').jScrollPane(); //TODO

        }

        resizeWindow (root) {

            $( window ).on( "resize", ( event )  => {

                this.changedSlickImageHeight(root);
                //nach 300 Milisekunden erneut aufrufen, um sicher zu gehen,
                //dass die korrekte Größe des Bildes verwendet wird
                setTimeout( () => {
                    this.changedSlickImageHeight(root);
                }, 300);

            });

        }

        /**
         * Passt die Höhe der Elemente der Höhe des Devices an, damit die Bilder
         * sich dem Bildschirm prozentuall anpassen können
         * @param {Selector} root
         * @param {Function} callback
         */
        changedSlickImageHeight (root, callback) {

            let device = $('#' + root.attr('id') + ' .zp-device-slider-device');
            let deviceHeight = device.innerHeight();
            let slickElement = $('#' + root.attr('id') + ' .zp-device-slider-element');
            slickElement.height(deviceHeight);

            let slickElements = $('#' + root.attr('id') + ' .zp-device-slider-elements');

            // let imageContainer = $('#' + root.attr('id') + ' .zp-device-slider-element-image-container');
            // let imageContainerWidth = imageContainer["0"].getBoundingClientRect().width;
            //
            // let background = $('#' + root.attr('id') + ' .zp-device-slider-background');
            // background.width(imageContainerWidth);


            let table = $('#' + root.attr('id') + ' .zp-device-slider-table');
            if (table.length > 0) {

                let tableHeight = table["0"].getBoundingClientRect().height;
                let sliderContainer = $('#' + root.attr('id') + ' .zp-device-slider-container');
                sliderContainer.height(tableHeight);


            }

            // console.log(slickElement);
            // console.log(deviceHeight);

            let scrollableElements = $('.zp-device-slider-elements').find('.zp-device-slider-element-scrollable');

            if (scrollableElements.length > 0) {


                scrollableElements.each(function () {
                    let $this = $(this);

                    let scrollableImage = $this.find('.zp-device-slider-element-image');

                    let scrollableImageForHeight = scrollableImage.find('.zp-device-slider-element-image-for-height');

                    let scrollableImageHeight = scrollableImageForHeight.innerHeight();

                    scrollableImage.height(scrollableImageHeight);
                });

            }


            if(typeof callback == "function") {
                callback();
            }
            // else if (mySlick) {
            //     // console.log(mySlick.slick('getSlick'));
            //     // mySlick.slick('reInit');
            // }

        }



    }

    return DeviceSlider;

}(window, document, jQuery)));